import React from 'react';

export default () => {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd" transform="">
        <path
          d="m18.3 5.7c-.3865993-.38659932-1.0134007-.38659932-1.4 0l-4.9 4.9-4.9-4.9c-.38659932-.38659932-1.01340068-.38659932-1.4 0s-.38659932 1.01340068 0 1.4l4.9 4.9-4.9 4.9c-.38659932.3865993-.38659932 1.0134007 0 1.4s1.01340068.3865993 1.4 0l4.9-4.9 4.9 4.9c.3865993.3865993 1.0134007.3865993 1.4 0s.3865993-1.0134007 0-1.4l-4.9-4.9 4.9-4.9c.3865993-.38659932.3865993-1.01340068 0-1.4z"
          fill="#828a99" fillRule="nonzero"/>
      </g>
    </svg>
  )
}
